/**
 * Slot to define the client's essential services that are not in the CMP.
 */
import { Consent } from '~/jobiqo/lib/cmp';

/**
 * Returns the essential services consents that are not in the CMP.
 *
 * @returns Consent[]
 *  Array of essential services consents in expected format.
 */
export const getEssentialServicesConsents = (): Consent[] => {
  return [];
};
export default getEssentialServicesConsents;
